module.exports = "/virtual-football/img/video/clubs/italy/milan.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/italy/milan.png
// module id = 302
// module chunks = 6